/* Terug naar de lijst zoals je hem achterliet, en vorige/volgende op een pagina in de
 * volgorde van die lijst. Per lijst een eigen plek in sessionStorage; zonder opslag
 * (privévenster) valt alles terug op de lijst zonder filter en geen vorige/volgende.
 *
 * Relatieve imports (geen @/), zodat de toetsen dit bestand zonder bundel lezen. */

export interface LijstGeheugen {
  /** `zoek` is de querystring van de filter zonder '?', `volgorde` de ids zoals getoond. */
  bewaar(zoek: string, volgorde: string[]): void;
  /** Het adres van de lijst met de laatste filter. */
  adres(): string;
  /** De ids in de volgorde van de lijst, of null. */
  volgorde(): string[] | null;
}

function opslag(): Storage | null {
  try {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage;
  } catch {
    return null;
  }
}

export function lijstGeheugen(naam: string, basis: string): LijstGeheugen {
  const zoekSleutel = `${naam}:zoek`;
  const volgordeSleutel = `${naam}:volgorde`;
  return {
    bewaar(zoek, volgorde) {
      try {
        opslag()?.setItem(zoekSleutel, zoek ? `?${zoek}` : '');
        opslag()?.setItem(volgordeSleutel, JSON.stringify(volgorde));
      } catch {
        /* geen opslag: dan zonder */
      }
    },
    adres() {
      try {
        return `${basis}${opslag()?.getItem(zoekSleutel) ?? ''}`;
      } catch {
        return basis;
      }
    },
    volgorde() {
      try {
        const v = JSON.parse(opslag()?.getItem(volgordeSleutel) ?? 'null');
        return Array.isArray(v) && v.every((x) => typeof x === 'string') ? v : null;
      } catch {
        return null;
      }
    },
  };
}

/** Vorige en volgende rond `id`; null als id er niet in staat. */
export function buren(volgorde: string[], id: string): { vorige: string | null; volgende: string | null; positie: number; totaal: number } | null {
  const i = volgorde.indexOf(id);
  if (i === -1) return null;
  return { vorige: volgorde[i - 1] ?? null, volgende: volgorde[i + 1] ?? null, positie: i + 1, totaal: volgorde.length };
}

/** Zoeken zonder hoofdletters en accenten: 'jose' vindt 'José'. */
export const kaal = (s: string | null | undefined): string =>
  (s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export function vindt(zoek: string, waarden: (string | null | undefined)[]): boolean {
  const z = kaal(zoek.trim());
  if (!z) return true;
  return waarden.some((v) => kaal(v).includes(z));
}
